import { sort } from 'ramda';
import { DHApp } from '../../shared/types';
/**
 * Sorts an array of DHApp objects based on their pinned weight.
 * @template T - The type of DHApp object in the array.
 * @param {Array<T>} apps - The array of DHApp objects to sort.
 * @returns {Array<T>} - The sorted array of DHApp objects.
 */
export const sortPinned = <T extends DHApp>(apps: Array<T>): Array<T> =>
  sort(
    ({ pinned: aPinned }, { pinned: bPinned }) =>
      (bPinned?.weight ?? 0) - (aPinned?.weight ?? 0),
    apps,
  );

/**
 * Retrieves an array of pinned apps and sorts them by their pinned weight.
 *
 * @param {Array<DHApp>} apps - An array of DHApp objects.
 * @returns {Array<DHApp>} - An array of DHApp objects sorted by their pinned weight.
 */
const getPinnedApps = (apps: Array<DHApp>) => {
  // Filter the apps array to only include pinned apps with enabled set to true
  const pinnedApps = apps.filter(
    ({ pinned }) => pinned && pinned.enabled === true,
  );

  // Sort the pinned apps array by their pinned weight
  const sortedPinnedApps = sortPinned(pinnedApps);

  return sortedPinnedApps;
};

export default getPinnedApps;
